import { dictionaryService } from "../../../dataFlow";
import { useDictionaryItem, useParameter } from "../../../shared";
import { SLIDE_NUMBER } from "../constants";

export function useSlideTitle() {
  const [commodityId] = useParameter<number>('@commodities_display');
  const [_, commodityNameLocale] = useDictionaryItem(dictionaryService, "slides-commodities-display", commodityId, {
    business_unit: 1,
    slide: SLIDE_NUMBER,
  });
  const commodityName = (commodityNameLocale || {} as any)[9];
  return [`Historical vs. Long Term Crop Commodity Prices`, commodityName].filter(Boolean).join(' — ');
}